<template>
  <div class="bet-list">
    <bet v-if="filter === 'all' || statuses[filter].indexOf(bet.status) !== -1" v-for="bet in bets" :key="bet.id" :bet="bet" />
  </div>
</template>

<script>
import Bet from '@/components/account/bets/Bet.vue'
import { mapState } from 'vuex'

export default {
  components: { Bet },
  computed: {
    ...mapState({
      filter: state => state.account.bets.filter,
      bets: state => state.account.bets.data
    })
  },
  data () {
    return {
      statuses: {
        open: [ 'placed', 'vip' ],
        winning: [ 'won' ],
        losing: [ 'lost' ],
        refund: [ 'refunded' ]
      }
    }
  }
}
</script>

<style scoped>
.bet-list { margin: 0 10px; }
.bet-list .bet:not(:first-child) { margin-top: 1px; }
.bet-list .bet:first-child { /* border-top-left-radius: 5px; border-top-right-radius: 5px; */ }
.bet-list .bet:last-child { /* border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; */ }
</style>



// WEBPACK FOOTER //
// src/components/account/bets/List.vue